/**
 * @file index.tsx
 *
 * @fileoverview Renders and image with some predefined properties like sizes and lazy loading.
 */

export interface ImageProps {
  /**
   * The image source.
   */
  src: string;
  /**
   * The image width.
   */
  width?: string;
  /**
   * The image height.
   */
  height?: string;
  /**
   * If the image should be lazy loaded.
   */
  lazy?: boolean;
  /**
   * The image alt attribute
   */
  alt: string;
  /**
   * The image title.
   */
  title?: string;
}

/**
 * Displays an image with optional lazy loading and size attributes.
 */
export const Image = ({
  src,
  width,
  height,
  lazy = true,
  alt,
  title,
}: ImageProps) => (
  <img
    src={src}
    {...(width ? { width } : null)}
    {...(height ? { height } : null)}
    {...(lazy ? { loading: "lazy" } : null)}
    alt={alt}
    {...(title ? { title } : null)}
  />
);

export default Image;
